// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"Q1bM8","rootCalendar":"_1bgxX","sideCalendar":"_3p9UF"};